module.exports = {"id":"220620","name":"Florent Hadergjonaj","rating":"72","photo":"./data/images/photos/4/220620.png","club":{"name":"Huddersfield","logo":"./data/images/clubs/Huddersfield.png"},"positions":["DD","DLD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FlorentHadergjonaj0.json
// module id = 1445
// module chunks = 0